(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qq-imagegallery"] && !Shopify.designMode) return;
  try {
    "use strict";function _typeof(e){return(_typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}!function(){function t(){var e=document.querySelectorAll(".qq-image-gallery .QQ-JS-init-msg");e&&e.forEach(function(e){e.remove()})}function n(){document.getElementsByClassName("qq-image-gallery").length&&function e(t){var n=document.createElement("script");n.id="qq-youtube";n.src="https://www.youtube.com/iframe_api";document.head.appendChild(n);{var i,a;null==("undefined"==typeof $?"undefined":_typeof($))||null==window.$?((n=document.createElement("script")).id="qq-jquery",document.head.appendChild(n),n.type="text/javascript",n.src="https://code.jquery.com/jquery-3.6.0.min.js",n.onload=function(){e()}):document.getElementById("qq-slick")&&document.getElementById("qq-slick-css")?i=setInterval(function(){$.fn.slick&&(clearInterval(i),s())},10):(document.getElementById("qq-slick")||((a=document.createElement("script")).id="qq-slick",document.head.appendChild(a),a.type="text/javascript",a.src="https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js",a.onload=function(){e()}),document.getElementById("qq-slick-css")||((a=document.createElement("link")).id="qq-slick-css",document.head.appendChild(a),a.type="text/css",a.rel="stylesheet",a.href="https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.css"))}}()}function s(){var e=document.getElementsByClassName("qq-image-gallery");if(e.length)for(var t=0;t<e.length;t++){var n="qq"+e[t].id.replace("template--","").replace("shopify-section-","").replace("__","");n=n,$("#"+n).length&&function(e){e=$("#"+e+" .qq-images-wrapper");l(e),function(a){var e=a.find(".qq-image-thumb"),s=a.parent().parent().find("#qq-popup"),l=s.find(".qq-popup-holder"),t=(s.find(".qq-popup-content"),s.find(".qq-popup-close")),n=Number(a.attr("data-numOfSlides")),o=s.find(".qq-popup-image-wrapper"),r=s.find(".qq-popup-image-title"),d=s.find(".qq-popup-image-subtitle"),i=s.find(".qq-carousel-arrow");s.find(".qq-carousel-prev"),s.find(".qq-carousel-next"),a.find(".slick-current").prev(),a.find(".slick-current").next();e.click(function(e){e.preventDefault(),a.find(".qq-active").removeClass("qq-active"),$(this).addClass("qq-active");var t=$(this).parent().find(".qq-image-title"),n=$(this).parent().find(".qq-image-subtitle"),i=$(this).find("picture").clone();s.hasClass("qq-open")||s.addClass("qq-open"),l.animate({opacity:0},100,function(){setTimeout(function(){o.html(i),r.text(t.text()),d.text(n.text()),function(e,t){t=t.outerHeight();e.css("height","calc(100% - "+t+"px)")}(o.parent(),r.parent()),setTimeout(function(){l.css("opacity","1")},100,l,o,r)},50)})}),i.click(function(e){e.preventDefault();var t=a.find(".qq-active"),e=Number(t.attr("data-slide")),e=$(this).hasClass("qq-carousel-prev")?e-1:e+1;e<1?e=n:n<e&&(e=1),e=a.find(".qq-single-image:not(.slick-cloned) .qq-image-thumb[data-slide='"+e+"']"),t.removeClass("qq-active"),e.trigger("click")}),t.click(function(e){e.preventDefault(),s.hasClass("qq-open")&&s.removeClass("qq-open"),r.add(d).text(""),o.html("")}),s.mouseup(function(e){"qq-popup"==e.target.id&&(s.removeClass("qq-open"),r.add(d).text(""),o.html(""))})}(e),function(t){var n=t.parent(),e=n.prev().find("a"),i=e.attr("data-expand"),a=e.attr("data-collapse");e.click(function(e){e.preventDefault(),$(this).hasClass("qq-active")?($(this).removeClass("qq-active"),$(this).text(i),l(t),n.removeClass("qq-expanded")):($(this).addClass("qq-active"),$(this).text(a),t.slick("unslick"),n.addClass("qq-expanded"))}),"grid"==t.attr("data-default")&&(e.length?e.trigger("click"):t.slick("unslick"))}(e)}(n)}}function l(i){var e=Boolean(i.attr("data-enableSlider")),t=Number(i.attr("data-slidesToShow")),n=/true/i.test(i.attr("data-carouselSlideAll")),a=/true/i.test(i.attr("data-carouselAutoplay")),s=/true/i.test(i.attr("data-carouselAutoplayMobile")),l=i.attr("data-carouselCentermode"),o=1e3*Number(i.attr("data-carouselSpeed")),r="false"!=(r=i.attr("data-carouselInfinite"))||!(l="false");"true"==l?d=!0:"false"==l&&(d=!1);var d,c,u,p=!1,q=$("html").attr("dir"),l=$("html").css("direction");(null!=q&&"rtl"==q||null!=_typeof(l)&&"rtl"==l)&&(p=!0,null==q&&$("html").attr("dir","rtl")),1==n?(c=t,d=u=!1):(c=1,u=!0);var l=i.parent().prev().find("a"),f=i.parent().find("span.qq-carousel-prev"),m=i.parent().find("span.qq-carousel-next"),q=f.parent(),n=i.find(".qq-single-image").length;768<$(window).width()?q.hasClass("qq-hidden")&&t<n&&q.add(l).removeClass("qq-hidden"):q.hasClass("qq-hidden")&&1<n&&q.add(l).removeClass("qq-hidden"),1==e&&i.not(".slick-initialized").on("init reInit setPosition",function(){var n=setInterval(function(){var e=i.find(".qq-single-image.slick-active").first().find("a.qq-image-thumb"),t=e.outerHeight(),e=(e.width(),f.add(m));0<t&&(clearInterval(n),798<$(window).width()?e.css("top",t/2-e.height()/2):e.css("top","inherit"),e.css("bottom","inherit"))},200)}).slick({infinite:r,loop:!0,slidesToShow:t,slidesToScroll:c,swipeToSlide:u,arrows:!0,rtl:p,prevArrow:f,nextArrow:m,autoplay:a,autoplaySpeed:a?o:void 0,centerMode:d,centerPadding:"5%",focusOnSelect:!0,responsive:[{breakpoint:768,settings:{centerPadding:"15%",slidesToShow:1,slidesToScroll:1,swipeToSlide:!0,autoplay:s}}]})}window.addEventListener("shopify:section:load",function(e){t()}),t(),"loading"!==document.readyState?n():document.addEventListener("DOMContentLoaded",function(){n()}),window.addEventListener("shopify:section:load",function(e){n()})}();
  } catch(e) { console.error(e); }
})();
})();
